import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { colors } from 'constants/colors';
import { styleSizes } from 'constants/styleSizes';

export const HintTrigger = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  flex-shrink: 0;
  cursor: help;

  > svg {
    flex-shrink: 0;
    overflow: visible;
  }
`;

export const HintTooltip = withStyles(() => ({
  popper: {
    zIndex: 2000,
  },
  popperInteractive: {
    // A moving desktop popup must not steal hover from its trigger.
    pointerEvents: 'none',
    [`@media (max-width: ${styleSizes.tabletBreakpoint})`]: {
      pointerEvents: 'auto',
    },
  },
  tooltip: {
    backgroundColor: colors.white,
    maxWidth: '350px',
    boxShadow: `0 0 5px 0 ${colors.borderGrey2}`,
    borderRadius: '0px',
    padding: '16px',
    boxSizing: 'border-box',
    color: colors.black,
    fontFamily: 'Titillium Web',
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 400,
    '& .hintTitle': {
      display: 'inline',
      color: colors.hoverBlue,
      fontWeight: 600,
      fontStyle: 'italic',
      marginRight: '8px',
    },
    '& .hintContent': {
      display: 'inline',
    },
  },
}))(Tooltip);
